/** TODO: static for now */
export const LOCATION_POINT_TYPES = [
    { id: 1, name: 'location', label: 'Location Point' },
]